import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LqipImageComponent } from './lqip-image.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LqipImageComponent],
  exports: [LqipImageComponent],
  providers: [],
})
export class LqipImageModule {}
